import gql from "graphql-tag"

/**
 * The indicator is connected to specificObjective and to the
 * submission through developmentObjectiveSubmission and generalObjectiveSubmission
 * relationships because the development objective and generalObjective entities
 * doesn't really exist
 */
export const GET_INDICATOR_BY_ID = gql`
  query GET_INDICATOR_BY_ID($id: ID!) {
    objectivesAndActivitiesTabIndicator(id: $id) {
      id
      goal
      products
      specificObjective {
        id
        submission {
          id
          startDate
          endDate
        }
      }
      developmentObjectiveSubmission {
        id
        name
        startDate
        endDate
      }
      generalObjectiveSubmission {
        id
        name
        startDate
        endDate
      }
      meansOfVerificationPerMonth {
        id
        month
        year
        monthProgress
        excessProgress
        isRevisionBlocked
        verificationDocumentsPerMonth {
          id
          url
          name
          type
        }
      }
    }
  }
`
